import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestPrint {
  type: DashboardActionTypes.REQUEST_PRINT;
  payload: {
    product: OrderProduct
    onEnd?: () => void
  }
}

export function requestPrint({
  product,
  onEnd,
}: RequestPrint['payload']): RequestPrint {
  return {
    type: DashboardActionTypes.REQUEST_PRINT,
    payload: {
      product,
      onEnd,
    },
  }
}

export interface RequestPrintSuccess {
  type: DashboardActionTypes.REQUEST_PRINT_SUCCESS;
  payload: {
    product: OrderProduct
  }
}

export function requestPrintSuccess({
  product,
}: RequestPrintSuccess['payload']): RequestPrintSuccess {

  return {
    type: DashboardActionTypes.REQUEST_PRINT_SUCCESS,
    payload: {
      product,
    },
  }
}

export interface RequestPrintFailure {
  type: DashboardActionTypes.REQUEST_PRINT_FAILURE;
  payload: {
    product: OrderProduct
    error: ApiError
  }
}

export function requestPrintFailure({
  product,
  error,
}: RequestPrintFailure['payload']): RequestPrintFailure {

  return {
    type: DashboardActionTypes.REQUEST_PRINT_FAILURE,
    payload: {
      product,
      error,
    },
  }
}
